/*
    This service validates the user has successfully logged-in and authorized to enter into the application
*/

export const validUserLoggedInAuthService = (isUserLoggedIn, isAuthorized) =>
  isUserLoggedIn && isAuthorized;
